import React from 'react';
import { Route, Switch } from 'react-router-dom';
import FullApplication from '../ordination/full_application';
import PostApplication from '../ordination/post_application'
import MinisterHelper from './minister_helper';


class OrdinationApp extends React.Component {
  constructor(props) {
    super(props);

    const certificateImagePath = this.getCertificateImagePath();

    this.state = {
      minister: this.savedPartialMinister() || MinisterHelper.empty(),
      certificateImagePath: certificateImagePath,
      acknowledgements: {
        policy: false,
        deliberate_request: false
      },
      serverErrors: [],
      newsletter_opt_in: false
    };

    this.updateModel = this.updateModel.bind(this);
    this.updateSubscription = this.updateSubscription.bind(this);
    this.updateAcknowledgement = this.updateAcknowledgement.bind(this);
    // this.updateFormError = this.updateFormError.bind(this)
  }

  static ministerCookieName() {
    return 'ordination-minister';
  }

  getCertificateImagePath() {
    return document.getElementById('ordination').getAttribute('data-certificate-image-path');
  }

  updateModel(key, value) {
    let cleanedValue;
    if(typeof value === 'string' || value instanceof String){
      cleanedValue = value.trim()
    }
    this.setState({
      minister: Object.assign({}, this.state.minister, { [key]: cleanedValue ? cleanedValue : value })
    }, () => { this.persistMinisterChanges(); });
  }

  updateAcknowledgement(key, value) {
    this.setState({
      acknowledgements: Object.assign({}, this.state.acknowledgements, { [key]: value })
    });
  }

  updateSubscription(key, value){
    this.setState({
      minister: Object.assign({}, this.state.minister, { newsletter_opt_in: value })
    }, () => { this.persistMinisterChanges(); });
  }

  persistMinisterChanges() {
    var safeMinister = Object.assign({}, this.state.minister, { password: '', password_confirmation: '' });
    const cookieMinister = JSON.stringify(safeMinister);
    document.cookie = `${OrdinationApp.ministerCookieName()}=${cookieMinister};path=/;`;
  }

  savedPartialMinister() {
    var minister = document.cookie.match(new RegExp(`${OrdinationApp.ministerCookieName()}=([^;]+)`));
    minister && (minister = JSON.parse(minister[1]));
    return minister;
  }

  clearPartialMinister() {
    document.cookie = `${OrdinationApp.ministerCookieName()}=${JSON.stringify(MinisterHelper.empty())};path=/;`;
  }
  render() {
    return (
      <Switch>
        <Route exact path='/' render={ () => <FullApplication updateSubscription={ this.updateSubscription } newsletter_opt_in={ this.state.newsletter_opt_in } minister={ this.state.minister } updateModel = { this.updateModel } savedPartialMinister = { this.savedPartialMinister } updateAcknowledgement={ this.updateAcknowledgement } acknowledgements={ this.state.acknowledgements } /> } />
        <Route path='/confirmation' render={ () =><PostApplication minister={ this.state.minister } clearPartialMinister={ this.clearPartialMinister } certificateImagePath={ this.state.certificateImagePath }  /> } />
      </Switch>
    )
  }
}

OrdinationApp.propTypes = {
};

export default OrdinationApp;
